import React from "react";
type SectionTitleProps = {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  tone?: "dark" | "light";
  className?: string;
};
export function SectionTitle({
  title,
  subtitle,
  tone = "dark",
  className = ""
}: SectionTitleProps) {
  const isDark = tone === "dark";
  return <div className={`mx-auto max-w-3xl text-center ${className}`} data-id="element-169" data-mp="4qh3p8zp6uo5">
      <h2 className={`font-display text-4xl font-bold uppercase leading-[0.95] sm:text-6xl ${isDark ? "text-white" : "text-forest"}`} data-id="element-170" data-mp="4strw3w1u19n">
        {title}
      </h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${isDark ? "text-white/75" : "text-forest/75"}`} data-id="element-171" data-mp="3r01uwzjhxw2i">{subtitle}</p>}
    </div>;
}